import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router);
import {Modal} from 'iview';


/*components文件目录
* pages页面,public公用组件
* a文件夹--管理端
* *************p(platform)文件夹--平台业务
* *************sc(school)文件夹--学校业务
* *************sy(system)文件夹--系统业务
* s文件夹--学生端
* t文件夹--教师端
* 路由按不同平台结构如下
* /a/login /管理端/登录  /a/p/major_manage /管理端/平台业务/专业管理  /a/sc/* /管理端/学校业务/某某   /a/sy/* 管理端/系统业务/某某
* /s/login /学生端/登录
* /t/login /教师端/登录
* */


// 判断不同端，页面的入口
var isPc = true
if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
  isPc = false;
  // console.log('移动端');
} else {
  isPc = true;
  // console.log('pc端');
}


var router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/ztree',   //首页
      name: 'ztree',
      component: resolve => require(['../components/public/ztree.vue'], resolve),
    },
     {
       path: '/',   //首页
       name: 'index',
       component(resolve) {
         if (isPc) {
           require(['../components/pages/index.vue'], resolve);
         } else {
           require(['../components/pages/mobile/main.vue'], resolve);
         }
       },
       children: [
         {
           path: '/',
           name: '',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/firstPage.vue'], resolve);
             } else {
               require(['../components/pages/mobile/firstPage.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
             keepAlive: true,
             isBack: false
           }
         },
         {
           path: '/introduce',
           name: 'introduce',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/introduce.vue'], resolve);
             } else {
               require(['../components/pages/mobile/introduce.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/aboutUs',
           name: 'aboutUs',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/aboutUs.vue'], resolve);
             } else {
               require(['../components/pages/mobile/aboutUs.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/contactUs',
           name: 'contactUs',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/contactUs.vue'], resolve);
             } else {
               require(['../components/pages/mobile/contactUs.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/online',
           name: 'online',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/errorQuestion.vue'], resolve);
             }else{
               require(['../components/pages/mobile/online.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/errorQuest',
           name: 'errorQuest',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/errorQuestion.vue'], resolve);
             } else {
               require(['../components/pages/mobile/errorQuestion.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/notice',
           name: 'notice',
           component(resolve) {
             require(['../components/pages/notice.vue'], resolve);
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/noticeDetail',
           name: 'noticeDetail',
           component(resolve) {
             require(['../components/pages/noticeDetail.vue'], resolve);
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/td',
           name: 'td',
           component(resolve) {
             require(['../components/pages/td.vue'], resolve);
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/lunbDetail',
           name: 'lunbDetail',
           component(resolve) {
             require(['../components/pages/lunbDetail.vue'], resolve);
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/helpOnline',
           name: 'helpOnline',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/helpOnline.vue'], resolve);
             } else {
               require(['../components/pages/mobile/helpOnline.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         /*{
           path: '/helpOnline',
           name: 'helpOnline',
           component(resolve) {
             if (isPc) {
               require(['../components/public/scroll.vue'], resolve);
             } else {
               require(['../components/pages/mobile/helpOnline.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },*/
         {
           path: '/course_detail',   //课程详情
           name: 'course_detail',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/course_detail.vue'], resolve);
             } else {
               require(['../components/pages/mobile/course_detail.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
           }
         },
         {
           path: '/course_list',   //课程列表
           name: 'course_list',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/course_list.vue'], resolve);
             } else {
               require(['../components/pages/mobile/course_list.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
             keepAlive: true,
             isBack: false
           }
         },
         {
           path: '/course_list_new',   //课程列表
           name: 'course_list_new',
           component(resolve) {
             if (isPc) {
               require(['../components/pages/course_list_new.vue'], resolve);
             } else {
              //  require(['../components/pages/mobile/course_list.vue'], resolve);
             }
           },
           meta: {
             title: '易测平台',
             keepAlive: true,
             isBack: false
           }
         }
       ]
     },
    {
      path: '/help',   //使用帮助
      name: 'help',
      component: resolve => require(['../components/pages/help.vue'], resolve),
    },


    /*管理端*/
    {
      path: '/a/login',   //管理员登录
      name: 'a_login',
      component: resolve => require(['../components/pages/a/login.vue'], resolve),
    },
    {
      path: '/a/main',  //管理员主页面
      redirect: to =>{

        // 页面设置重定向，后台管理系统路由控制权限判断跳转方式
        var redireUrl = ''

        if(JSON.parse(sessionStorage.getItem('auser'))){

          var tabTitle = JSON.parse(sessionStorage.getItem('auser')).authority.tab
          if(tabTitle.platbusiness == 1){
            redireUrl = '/a/p/major'
          }else if(tabTitle.platbusiness == 0 && tabTitle.schoolbusiness == 1){
            redireUrl = '/a/sc/grade'
          }else if(tabTitle.platbusiness == 0 && tabTitle.schoolbusiness == 0 && tabTitle.sysmanager == 1){
            redireUrl = '/a/sy/region'
          }
        }else{

          redireUrl = '/a/p/major'
        }

        return redireUrl;
      },
      component: resolve => require(['../components/pages/a/main.vue'], resolve),
      children: [
        {
          path: '/a/p', //平台业务
          name: 'a_platform',
          component: resolve => require(['../components/pages/a/platform.vue'], resolve),
          redirect: '/a/p/major',
          children: [
            {
              path: '/a/p/major', //专业管理
              name: 'major',
              component: resolve => require(['../components/pages/a/p/major.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/course', //课程
              name: 'course',
              component: resolve => require(['../components/pages/a/p/course.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/version', //版本
              name: 'version',
              component: resolve => require(['../components/pages/a/p/version.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser',
           /*     keepAlive: true,
                isBack: false*/
              }
            },
            {
              path: '/a/p/knowlee', //上传文档管理
              name: 'knowlee',
              component: resolve => require(['../components/pages/a/p/knowlee.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/version/examConfig', //考试配置列表
              name: 'examConfig',
              component: resolve => require(['../components/pages/a/p/examConfig.vue'], resolve),
              meta: {
                subname: 'quesbank'
              }
            },
            {
              path: '/a/p/knowledge', //知识点
              name: 'knowledge',
              component: resolve => require(['../components/pages/a/p/knowledge.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/quesbank', //题库
              name: 'quesbank',
              component: resolve => require(['../components/pages/a/p/quesbank.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/question', //试题维护
              name: 'question',
              component: resolve => require(['../components/pages/a/p/question.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/select_knows_to_homework',
              name: 'question',
              component: resolve => require(['../components/pages/a/p/select_knows_to_homework.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser',
                keepAlive: true,
                isBack: false,
              }
            },
            {
              path: '/a/p/set_homework_half',
              name: 'set_homework_half',
              component: resolve => require(['../components/pages//a/p/set_homework_half.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser',
                keepAlive: true,
                isBack: false,
              }
            },
            {
              path: '/a/p/quesBankAuthor', //题库授权
              name: 'quesBankAuthor',
              component: resolve => require(['../components/pages/a/p/quesBankAuthor.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/scageny', //日常维护--学校管理--学校机构
              name: 'scageny',
              component: resolve => require(['../components/pages/a/p/scageny.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/scuser', //日常维护--学校管理--学校人员
              name: 'scuser',
              component: resolve => require(['../components/pages/a/p/scuser.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/examinationMessage', //日常维护--试卷管理
              name: 'examinationMessage',
              component: resolve => require(['../components/pages/a/p/examinationMessage.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
                /*keepAlive: true,
                isBack: false,*/
              }
            },
            {
              path: '/a/p/errorForm', //错题反馈
              name: 'errorForm',
              component: resolve => require(['../components/pages/a/p/errorForm.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
              }
            },
            {
              path: '/a/p/errorFormAll', //错题反馈
              name: 'errorFormAll',
              component: resolve => require(['../components/pages/a/p/errorFormAll.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
                activeName:"/a/p/errorForm"
              }
            },
            {
              path: '/a/p/feedForm', //页面功能反馈
              name: 'feedForm',
              component: resolve => require(['../components/pages/a/p/feedForm.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
              }
            },
            {
              path: '/a/p/buyOrgan', //购买机构
              name: 'buyOrgan',
              component: resolve => require(['../components/pages/a/p/buyOrgan.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
              }
            },
            {
              path: '/a/p/buyOrgan_children', //购买机构下级
              name: 'buyOrgan_children',
              component: resolve => require(['../components/pages/a/p/buyOrgan_children.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
                activeName:"/a/p/buyOrgan"
              }
            },
            {
              path: '/a/p/ques_check', //日常维护--试卷管理--查看试卷
              name: 'ques_check',
              component: resolve => require(['../components/pages/a/p/ques_check.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
                activeName: '/a/p/examinationMessage',
              }
            },
            {
              path: '/a/p/exerciseListDesc', //日常维护--试卷管理--查看试卷--查看试题
              name: 'exerciseListDesc',
              component: resolve => require(['../components/pages/a/p/exerciseListDesc.vue'], resolve),
              meta: {
                subname: 'dailymanage',
                requireAuth: 'auser',
                activeName: '/a/p/examinationMessage'
              }
            },
            {
              path: '/a/p/cates', //首页管理--课程管理
              name: 'cates',
              component: resolve => require(['../components/pages/a/p/cates.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/cates_sx', //首页管理--上新管理
              name: 'cates_sx',
              component: resolve => require(['../components/pages/a/p/cates_sx.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/hots', //首页管理--课程分类管理
              name: 'hots',
              component: resolve => require(['../components/pages/a/p/hots.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/homeCourses', //首页管理--课程信息维护
              name: 'homeCourses',
              component: resolve => require(['../components/pages/a/p/homeCourses.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/apply_recordList', //首页管理--申请记录
              name: 'apply_recordList',
              component: resolve => require(['../components/pages/a/p/apply_recordList.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/group', //团队管理
              name: 'group',
              component: resolve => require(['../components/pages/a/p/group.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/slidShow', //轮播图管理
              name: 'slidShow',
              component: resolve => require(['../components/pages/a/p/slidShow.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/notice', //公告管理
              name: 'notice',
              component: resolve => require(['../components/pages/a/p/notice.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/pt_systemMessage', //平台->>系统消息
              name: 'pt_systemMessage',
              component: resolve => require(['../components/pages/a/p/pt_systemMessage.vue'], resolve),
              meta: {
                subname: 'message',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/creator',
              name: 'creator',
              component: resolve => require(['../components/pages/a/p/creator.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser',
                activeName: '/a/p/apply_recordList'
              }
            },
            {
              path: '/a/p/emailDetail',
              name: 'emailDetail',
              component: resolve => require(['../components/pages/a/p/emailDetail.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser',
                activeName: '/a/p/apply_recordList'
              }
            },
            {
              path: '/a/p/errorQuestList', //首页管理--错题登记在线投稿
              name: 'errorQuestList',
              component: resolve => require(['../components/pages/a/p/errorQuestList.vue'], resolve),
              meta: {
                subname: 'firstPage',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/examConfig', //字典管理
              name: 'examConfig',
              component: resolve => require(['../components/pages/a/p/examConfig.vue'], resolve),
              meta: {
                subname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/questionList', //问题列表
              name: 'questionList',
              component: resolve => require(['../components/pages/a/p/questionList.vue'], resolve),
              meta: {
                subname: 'questionAnswer',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/answerList', //问答列表
              name: 'answerList',
              component: resolve => require(['../components/pages/a/p/answerList.vue'], resolve),
              meta: {
                subname: 'questionAnswer',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/schoolStatics', //查询统计--学校统计
              name: 'schoolStatics',
              component: resolve => require(['../components/pages/a/p/schoolStatics.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/schoolStatics_now', //查询统计--学校实时统计
              name: 'schoolStatics_now',
              component: resolve => require(['../components/pages/a/p/schoolStatics_now.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/exam_list', //统计查看考试列表
              name: 'exam_list',
              component: resolve => require(['../components/pages/a/p/exam_list.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser',
                activeName:"/a/p/schoolStatics_now"
              }
            },
            {
              path: '/a/p/libAuthStatistics', //查询统计--题库授权统计
              name: 'libAuthStatistics',
              component: resolve => require(['../components/pages/a/p/libAuthStatistics.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/quesbank_new', //查询统计--题库授权统计(新)
              name: 'quesbank_new',
              component: resolve => require(['../components/pages/a/p/quesbank_new.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/quesNumStatics', //查询统计--试题数量统计
              name: 'quesNumStatics',
              component: resolve => require(['../components/pages/a/p/quesNumStatics.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/p/knowStatics', //查询统计--知识点统计
              name: 'knowStatics',
              component: resolve => require(['../components/pages/a/p/knowStatics.vue'], resolve),
              meta: {
                subname: 'statics',
                requireAuth: 'auser'
              }
            },




          ]
        },
        {
          path: '/a/sc', //学校业务
          name: 'a_school',
          component: resolve => require(['../components/pages/a/school.vue'], resolve),
          redirect: '/a/sc/grade',
          children: [
            {
              path: '/a/sc/grade',  // 班级管理
              name: 'grade',
              component: resolve => require(['../components/pages/a/sc/grade.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/student',  // 学生管理
              name: 'student',
              component: resolve => require(['../components/pages/a/sc/student.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/teacher',  // 教师管理
              name: 'teacher',
              component: resolve => require(['../components/pages/a/sc/teacher.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },

            {
              path: '/a/sc/teaching_records',  // 授课记录管理
              name: 'teaching_records',
              component: resolve => require(['../components/pages/a/sc/teaching_records.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/question', //试题维护
              name: 'sc_question',
              component: resolve => require(['../components/pages/a/sc/question.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/authoredLibs', //已授权题库
              name: 'authoredLibs',
              component: resolve => require(['../components/pages/a/sc/authoredLibs.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/knowlee', //上传文档管理
              name: 'sc_knowlee',
              component: resolve => require(['../components/pages/a/sc/knowlee.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/teacherResources', //教学资源管理
              name: 'teacherResources',
              component: resolve => require(['../components/pages/a/sc/teacherResources.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/quesbank', //题库
              name: 'sc_quesbank',
              component: resolve => require(['../components/pages/a/sc/quesbank.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/schoolscuser', //题库
              name: 'schoolscuser',
              component: resolve => require(['../components/pages/a/sc/schoolscuser.vue'], resolve),
              meta: {
                subname: 'organ',
                childsubname: 'quesbank',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/schoolscageny', //学校机构
              name: 'schoolscageny',
              component: resolve => require(['../components/pages/a/sc/schoolscageny.vue'], resolve),
              meta: {
                subname: 'organ',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/schoolcourse', //学校人员
              name: 'schoolcourse',
              component: resolve => require(['../components/pages/a/sc/schoolcourse.vue'], resolve),
              meta: {
                subname: 'business',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/teacherstatics', //老师状况查询
              name: 'teacherstatics',
              component: resolve => require(['../components/pages/a/sc/teacherstatics.vue'], resolve),
              meta: {
                subname: 'total',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/knowStatics', //知识点统计
              name: 'knowStatics',
              component: resolve => require(['../components/pages/a/sc/knowStatics.vue'], resolve),
              meta: {
                subname: 'total',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/questionList', //问题列表
              name: 'questionList',
              component: resolve => require(['../components/pages/a/p/questionList.vue'], resolve),
              meta: {
                subname: 'questionList_school',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/answerList', //问答列表
              name: 'answerList',
              component: resolve => require(['../components/pages/a/p/answerList.vue'], resolve),
              meta: {
                subname: 'questionList_school',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sc/examinationMessage', //日常维护--试卷管理
              name: 'examinationMessage',
              component: resolve => require(['../components/pages/a/sc/examinationMessage.vue'], resolve),
              meta: {
                subname: 'total',
                requireAuth: 'auser',
                /*keepAlive: true,
                isBack: false*/
              }
            },
            {
              path: '/a/sc/schoolTotal', //日常维护--学校统计
              name: 'schoolTotal',
              component: resolve => require(['../components/pages/a/sc/schoolTotal.vue'], resolve),
              meta: {
                subname: 'total',
                requireAuth: 'auser',
              }
            },
            {
              path: '/a/sc/ques_check', //日常维护--试卷管理--查看试卷
              name: 'ques_check',
              component: resolve => require(['../components/pages/a/sc/ques_check.vue'], resolve),
              meta: {
                subname: 'total',
                requireAuth: 'auser',
                activeName: '/a/sc/examinationMessage',
              }
            },
            {
              path: '/a/sc/exerciseListDesc', //日常维护--试卷管理--查看试卷--查看试题
              name: 'exerciseListDesc',
              component: resolve => require(['../components/pages/a/sc/exerciseListDesc.vue'], resolve),
              meta: {
                subname: 'total',
                requireAuth: 'auser',
                activeName: '/a/sc/examinationMessage'
              }
            },
            {
              path: '/a/sc/systemMessage', //问答列表
              name: 'systemMessage',
              component: resolve => require(['../components/pages/a/sc/systemMessage.vue'], resolve),
              meta: {
                subname: 'message',
                requireAuth: 'auser'
              }
            },


          ],
        },
        {
          path: '/a/sy', //系统管理
          name: 'a_system',
          component: resolve => require(['../components/pages/a/system.vue'], resolve),
          redirect: '/a/sy/region',
          children: [
            {
              path: '/a/sy/region', //区域管理
              name: 'region',
              component: resolve => require(['../components/pages/a/sy/region.vue'], resolve),
              meta: {
                subname: 'user',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/agency', //机构管理
              name: 'agency',
              component: resolve => require(['../components/pages/a/sy/agency.vue'], resolve),
              meta: {
                subname: 'user',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/user', //用户管理
              name: 'user',
              component: resolve => require(['../components/pages/a/sy/user.vue'], resolve),
              meta: {
                subname: 'user',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/menu', //菜单管理
              name: 'menu',
              component: resolve => require(['../components/pages/a/sy/menu.vue'], resolve),
              meta: {
                subname: 'system',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/logList', //字典管理
              name: 'dictionary',
              component: resolve => require(['../components/pages/a/sy/logList.vue'], resolve),
              meta: {
                subname: 'system',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/dictionary', //字典管理
              name: 'dictionary',
              component: resolve => require(['../components/pages/a/sy/dictionary.vue'], resolve),
              meta: {
                subname: 'system',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/role', //角色管理
              name: 'role',
              component: resolve => require(['../components/pages/a/sy/role.vue'], resolve),
              meta: {
                subname: 'system',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/questionType', //字典管理
              name: 'questionType',
              component: resolve => require(['../components/pages/a/sy/questionType.vue'], resolve),
              meta: {
                subname: 'system',
                requireAuth: 'auser'
              }
            },
            {
              path: '/a/sy/agreement', // 用户协议
              name: 'agreement',
              component: resolve => require(['../components/pages/a/sy/agreement.vue'], resolve),
              meta: {
                subname: 'system',
                requireAuth: 'auser'
              }
            },

          ]
        },
      ]
    },


    /*学生端*/
    {
      path: '/s/login',   //学生端登录
      name: 's_login',
      component: resolve => require(['../components/pages/s/login.vue'], resolve),
    },
    {
      path: '/s/quesListPaper', //答题页面
      name: 'quesListPaper',
      component: resolve => require(['../components/pages/s/quesListPaper.vue'], resolve),
      meta: {
        subname: 'practise',
        requireAuth: 'suser',
        allowBack: 0
      }
    },
    {
      path: '/s/mokQuesDesc', //模拟卷作答页面
      name: 'mokQuesDesc',
      component: resolve => require(['../components/pages/s/mokQuesDesc.vue'], resolve),
      meta: {
        subname: 'practise',
        requireAuth: 'suser',
        activeName: '/s/mokList',
        allowBack: 0
      }
    },
    {
      path: '/s/main', //学生端系统主界面
      component: resolve => require(['../components/pages/s/main.vue'], resolve),
      redirect: '/s/index',
      children: [
        {
          path: '/s/index', //系统管理
          name: 's_index',
          component: resolve => require(['../components/pages/s/index.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/change_course',   //更换课程
          name: 'change_course',
          component: resolve => require(['../components/pages/s/change_course.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/exam', //我的考试
          name: 's_exam',
          component: resolve => require(['../components/pages/s/exam.vue'], resolve),
          meta: {}
        },
        {
          path: '/s/question_list', //题目展示列表
          name: 's_question_list',
          component: resolve => require(['../components/pages/s/question_list.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/question_bank', //题目展示列表
          name: 's_question_bank',
          component: resolve => require(['../components/pages/s/question_bank.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/practiceList', //随堂练习列表
          name: 's_practiceList',
          component: resolve => require(['../components/pages/s/practiceList.vue'], resolve),
          meta: {
            requireAuth: 'suser',
            subname: 'classroom',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/practiceTest', //随堂练习
          name: 'practiceTest',
          component: resolve => require(['../components/pages/s/practiceTest.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/mokList', //模拟卷入口列表
          name: 'mokList',
          component: resolve => require(['../components/pages/s/mokList.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser'
          }
        },

        {
          path: '/s/checkMokQuesDesc', //模拟卷查看详情页面
          name: 'checkMokQuesDesc',
          component: resolve => require(['../components/pages/s/checkMokQuesDesc.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser',
            activeName: '/s/mokList'
          }
        },


        {
          path: '/s/secTestList', //分章练习入口列表
          name: 'secTestList',
          component: resolve => require(['../components/pages/s/secTestList.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/secQuesDesc', //分章练习题目详情
          name: 'secQuesDesc',
          component: resolve => require(['../components/pages/s/secQuesDesc.vue'], resolve),
          meta: {
            subname: 'practise',
            activeName: '/s/secTestList',
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/checkSecQuesDesc', //做过分章练习后,查看题目详情
          name: 'checkSecQuesDesc',
          component: resolve => require(['../components/pages/s/checkSecQuesDesc.vue'], resolve),
          meta: {
            subname: 'practise',
            activeName: '/s/secTestList',
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/knowTestList', //按知识点浏览试题入口
          name: 'knowTestList',
          component: resolve => require(['../components/pages/s/knowTestList.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/knowQuesDesc', //按知识点刷题作答页面
          name: 'knowQuesDesc',
          component: resolve => require(['../components/pages/s/knowQuesDesc.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser',
            activeName: '/s/knowTestList',
          }
        },
        {
          path: '/s/wrong', //错题集入口
          name: 'wrong',
          component: resolve => require(['../components/pages/s/wrong.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/wrongQuesList', //错题集试题列表
          name: 'wrongQuesList',
          component: resolve => require(['../components/pages/s/wrongQuesList.vue'], resolve),
          meta: {
            subname: 'practise',
            activeName: '/s/wrong',
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/wrongRelative', //错题集试题相关
          name: 'wrongRelative',
          component: resolve => require(['../components/pages/s/wrongRelative.vue'], resolve),
          meta: {
            subname: 'practise',
            activeName: '/s/wrong',
            requireAuth: 'suser'
          }
        },


        {
          path: '/s/unHaveExercisePage', //未设置练习题页面
          name: 'unHaveExercisePage',
          component: resolve => require(['../components/pages/s/unHaveExercisePage.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser'
          }
        },

        /*{
          path: '/s/quesListPaper', //答题页面
          name: 'quesListPaper',
          component: resolve => require(['../components/pages/s/quesListPaper.vue'], resolve),
          meta:{
            subname:'practise',
            requireAuth:'suser'
          }
        },*/
        {
          path: '/s/checkQuesPeperDesc', //查看试题列表页面
          name: 'checkQuesPeperDesc',
          component: resolve => require(['../components/pages/s/checkQuesPeperDesc.vue'], resolve),
          meta: {
            subname: 'practise',
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/exampleList', //课堂例题列表
          name: 'exampleList',
          component: resolve => require(['../components/pages/s/exampleList.vue'], resolve),
          meta: {
            subname: 'classroom',
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },


        {
          path: '/s/homeworkList', //课后作业列表
          name: 'homeworkList',
          component: resolve => require(['../components/pages/s/homeworkList.vue'], resolve),
          meta: {
            subname: 'classroom',
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/examOnlineList', //我的考试列表
          name: 'examOnlineList',
          component: resolve => require(['../components/pages/s/examOnlineList.vue'], resolve),
          meta: {
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/studentTotal_stu_test_sort', //我的考试列表
          name: 'studentTotal_stu_test_sort',
          component: resolve => require(['../components/pages/s/studentTotal_stu_test_sort.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        },
        {
          path: '/s/checkExamplePeperDesc', //课堂例题题目详情
          name: 'checkExamplePeperDesc',
          component: resolve => require(['../components/pages/s/checkExamplePeperDesc.vue'], resolve),
          meta: {
            subname: 'classroom',
            requireAuth: 'suser',
            activeName: '/s/exampleList'
          }
        },
        {
          path: '/s/CalculatorContent', //课堂例题题目详情
          name: 'CalculatorContent',
          component: resolve => require(['../components/public/CalculatorContent.vue'], resolve),
          meta: {
            subname: 'classroom',
            requireAuth: 'suser',
            activeName: '/s/exampleList'
          }
        },
        {
          path: '/s/myComment', //课堂例题题目详情
          name: 'myComment',
          component: resolve => require(['../components/pages/s/myComment.vue'], resolve),
          meta: {
            requireAuth: 'suser',
          }
        },
        {
          path: '/s/answerQuestion', //互问互答
          name: 'answerQuestion',
          component: resolve => require(['../components/pages/s/answerQuestion.vue'], resolve),
          meta: {
            requireAuth: 'suser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/answerQuestion2', //互问互答
          name: 'answerQuestion2',
          component: resolve => require(['../components/pages/s/answerQuestion2.vue'], resolve),
          meta: {
            subname: 'answerQuestion',
            requireAuth: 'suser',
            activeName: '/s/answerQuestion',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/s/answerQuestion3', //回复详情
          name: 'answerQuestion3',
          component: resolve => require(['../components/pages/s/answerQuestion3.vue'], resolve),
          meta: {
            subname: 'answerQuestion',
            requireAuth: 'suser',
            activeName: '/s/answerQuestion'
          }
        },
        {
          path: '/s/scourseList',
          name: 'scourseList',
          component: resolve => require(['../components/pages/s/scourseList.vue'], resolve),
          meta: {
            requireAuth: 'suser'
          }
        }
      ]
    },


    /*教师端*/
    {
      path: '/t/login',   //教师端登录
      name: 't_login',
      component: resolve => require(['../components/pages/t/login.vue'], resolve),
    },
    {
      path: '/t/main', //教师端系统主界面
      component: resolve => require(['../components/pages/t/main.vue'], resolve),
      redirect: '/t/index',
      children: [
        {
          path: '/t/index', //教师端首页
          name: 't_index',
          component: resolve => require(['../components/pages/t/index.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },

        {
          path: '/t/select_knows_to_exam',   //组卷知识点选择
          name: 'select_knows_to_exam',
          component: resolve => require(['../components/pages/t/select_knows_to_exam.vue'], resolve),
          meta: {
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/sheet',   //签到页面
          name: 'sheet',
          component: resolve => require(['../components/pages/t/sheet.vue'], resolve),
          meta: {
            activeName: '/t/index',
            requireAuth: 'tuser'
          }
        },

        {
          path: '/t/creat_examPaper2',   //新建试卷2
          name: 'creat_examPaper2',
          component: resolve => require(['../components/pages/t/creat_examPaper2.vue'], resolve),
          meta: {
            subname: 'exam',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/set_examPaper_hand',   //手动组卷（旧）
          name: 'set_examPaper_hand',
          component: resolve => require(['../components/pages/t/set_examPaper_hand.vue'], resolve),
          meta: {
            activeName: '/t/index',
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/hand_group',   //手动组卷（新）
          name: 'hand_group',
          component: resolve => require(['../components/pages/t/hand_group.vue'], resolve),
          meta: {
            activeName: '/t/index',
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/test_set_common',
          name: 'test_set_common',
          component: resolve => require(['../components/pages/t/common/test_set_common.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'exam',
            activeName: '/t/exam_online_list'
          }
        },
        {
          path: '/t/set_examPaper_hand_save',   //手动组卷保存
          name: 'set_examPaper_hand_save',
          component: resolve => require(['../components/pages/t/set_examPaper_hand_save.vue'], resolve),
          meta: {
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/set_examPaper_half',   //半自动组卷
          name: 'set_examPaper_half',
          component: resolve => require(['../components/pages/t/set_examPaper_half.vue'], resolve),
          meta: {
            activeName: '/t/index',
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/set_examPaper_auto',   //自动组卷
          name: 'set_examPaper_auto',
          component: resolve => require(['../components/pages/t/set_examPaper_auto.vue'], resolve),
          meta: {
            activeName: '/t/index',
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/exam_ques_adjust_underline',   //考试题目调整(线下)
          name: 'exam_ques_adjust_underline',
          component: resolve => require(['../components/pages/t/exam_ques_adjust_underline.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/exam_ques_check_underline',   //考试题目查看(线下)
          name: 'exam_ques_check_underline',
          component: resolve => require(['../components/pages/t/exam_ques_check_underline.vue'], resolve),
          meta: {
            subname: 'exam',
            requireAuth: 'tuser',
            activeName: '/t/exam_underline_list'
          },
        },
        {
          path: '/t/test_set_common_down',   //考试设置
          name: 'test_set_common_down',
          component: resolve => require(['../components/pages/t/common/test_set_common_down.vue'], resolve),
          meta: {
            subname: 'exam',
            requireAuth: 'tuser',
            activeName: '/t/exam_underline_list'
          }
        },

        {
          path: '/t/exam_ques_adjust_online',   //考试题目调整(线上)
          name: 'exam_ques_adjust_online',
          component: resolve => require(['../components/pages/t/exam_ques_adjust_online.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
          }
        },
        {
          path: '/t/exam_ques_check_online',   //考试题目查看(线上)
          name: 'exam_ques_check_online',
          component: resolve => require(['../components/pages/t/exam_ques_check_online.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'exam',
            activeName: '/t/exam_online_list'
          }
        },
        {
          path: '/t/select_knows_to_homework',   //课后作业知识点选择
          name: 'select_knows_to_homework',
          component: resolve => require(['../components/pages/t/select_knows_to_homework.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
          }
        },
        {
          path: '/t/set_homework_half',   //半自动课后作业
          name: 'set_homework_half',
          component: resolve => require(['../components/pages/t/set_homework_half.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
          }
        },
        {
          path: '/t/set_homework_hand',   //手动课后作业
          name: 'set_homework_hand',
          component: resolve => require(['../components/pages/t/set_homework_hand.vue'], resolve),
          meta: {
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
            requireAuth: 'tuser'
          }
        },

        {
          path: '/t/set_homework_hand_save',   //手动课后作业保存
          name: 'set_homework_hand_save',
          component: resolve => require(['../components/pages/t/set_homework_hand_save.vue'], resolve),
          meta: {
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/homework_ques_adjust',   //课后作业题目调整
          name: 'homework_ques_adjust',
          component: resolve => require(['../components/pages/t/homework_ques_adjust.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/title_adjust',   //新建试卷穿梭狂的下一步，确认考试细节页面,题目调整
          name: 'title_adjust',
          component: resolve => require(['../components/pages/t/title_adjust.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/openExam',   //新建试卷穿梭狂的下一步，确认考试细节页面,题目调整，查看A卷按钮
          name: 'openExam',
          component: resolve => require(['../components/pages/t/openExam.vue'], resolve),
        },
        {
          path: '/t/paper_detail_common',
          name: 'paper_detail_common',
          component: resolve => require(['../components/pages/t/common/paper_detail_common.vue'], resolve),
        },
        {
          path: '/t/paper_details',
          name: 'paper_details',
          component: resolve => require(['../components/pages/t/paper_details.vue'], resolve),
          meta: {
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/paper_details_auto',
          name: 'paper_details_auto',
          component: resolve => require(['../components/pages/t/paper_details_auto.vue'], resolve),
          meta: {
            activeName: '/t/index',
            keepAlive: true,
            isBack: false,
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/exam_online_list',   //线上考试列表（已结束的考试和未结束的考试列表）
          name: 'exam_online_list',
          component: resolve => require(['../components/pages/t/exam_online_list.vue'], resolve),
          meta: {
            subname: 'exam',
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/scan_unsubmit_examonline',   //线上考试查看未答题人员
          name: 'scan_unsubmit_examonline',
          component: resolve => require(['../components/pages/t/scan_unsubmit_examonline.vue'], resolve),
          meta: {
            subname: 'exam',
            requireAuth: 'tuser',
            activeName: '/t/exam_online_list'
          }
        },

        {
          path: '/t/Exam_info',   //查看试卷信息
          name: 'Exam_info',
          component: resolve => require(['../components/pages/t/Exam_info.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/okExam_questionList',   //A卷查看（查看某张试卷的所有题）
          name: 'okExam_questionList',
          component: resolve => require(['../components/pages/t/okExam_questionList.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/exam_status_editScore',   //A卷查看（修改成绩）
          name: 'exam_status_editScore',
          component: resolve => require(['../components/pages/t/exam_status_editScore.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/exam_status_lookScore',   //A卷查看（查看成绩）
          name: 'exam_status_lookScore',
          component: resolve => require(['../components/pages/t/exam_status_lookScore.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/exam_status_echart',   //A卷查看（查看统计）
          name: 'exam_status_echart',
          component: resolve => require(['../components/pages/t/exam_status_echart.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/Examination_control',   //考试监控（考试管理模块）
          name: 'Examination_control',
          component: resolve => require(['../components/pages/t/Examination_control.vue'], resolve),
          meta: {
            subname: 'exam',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/Examination_controlDesc',   //考试监控查看详情（考试管理模块）
          name: 'Examination_controlDesc',
          component: resolve => require(['../components/pages/t/Examination_controlDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/answer_question',   //互问互答
          name: 'answer_question',
          component: resolve => require(['../components/pages/t/answer_question.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/answer_questionDesc',   //互问互答
          name: 'answer_questionDesc',
          component: resolve => require(['../components/pages/t/answer_questionDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/student_comment_class',   //学生评语,班级列表
          name: 'student_comment_class',
          component: resolve => require(['../components/pages/t/student_comment_class.vue'], resolve),
          meta: {
            subname: 'teaStd',
            requireAuth: 'tuser',
          }
        },
        {
          path: '/t/student_comment',   //学生评语学生列表
          name: 'student_comment',
          component: resolve => require(['../components/pages/t/student_comment.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'teaStd',
            keepAlive: true,
            isBack: false,
            activeName: '/t/student_comment_class'
          }
        },
        {
          path: '/t/student_comment_reviews',   //已评学生评语列表
          name: 'student_comment_reviews',
          component: resolve => require(['../components/pages/t/student_comment_reviews.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'teaStd',
            activeName: '/t/student_comment_class'

          }
        },
        {
          path: '/t/quesbank',   //自建试题--题库维护
          name: 'tquesbank',
          component: resolve => require(['../components/pages/t/quesbank.vue'], resolve),
          meta: {
            subname: 'selfBuilt',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/question',   //试题维护
          name: 't_question',
          component: resolve => require(['../components/pages/t/question.vue'], resolve),
          meta: {
            subname: 'selfBuilt',
            requireAuth: 'tuser'
          }
        },

        {
          path: '/t/knowledgeMessage',   //知识点管理
          name: 'knowledgeMessage',
          component: resolve => require(['../components/pages/t/knowledgeMessage.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/ExamplesList',   //课堂例题--列表
          name: 'ExamplesList',
          component: resolve => require(['../components/pages/t/ExamplesList.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false,
          }
        },
        {
          path: '/t/exampleListDesc', //课堂例题详情
          name: 'exampleListDesc',
          component: resolve => require(['../components/pages/t/exampleListDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/ExamplesList'
          }
        },
        {
          path: '/t/exerciseInRoom',   //随堂评测--列表
          name: 'exerciseInRoom',
          component: resolve => require(['../components/pages/t/exerciseInRoom.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/exam_pool',   //试卷池
          name: 'exam_pool',
          component: resolve => require(['../components/pages/t/exam_pool.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            // keepAlive: true,
          }
        },
        {
          path: '/t/history_file',  // 查看历史记录
          name: 'history_file',
          component: resolve => require(['../components/pages/t/history_file.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
          }
        },
        {
          path: '/t/exam_paper_detail',   //试卷池查看试卷详情
          name: 'exam_paper_detail',
          component: resolve => require(['../components/pages/t/common/exam_paper_detail.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            activeName : "/t/exam_pool",
            subname : ""
          }
        },
        {
          path: '/t/save_collectPage',   //试卷池查看试卷详情
          name: 'save_collectPage',
          component: resolve => require(['../components/pages/t/common/save_collectPage.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            activeName : "/t/exam_pool",
            subname : ""
          }
        },
        {
          path: '/t/exercise_controlDesc',   //随堂评测--监控
          name: 'exercise_controlDesc',
          component: resolve => require(['../components/pages/t/exercise_controlDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/exerciseInRoom'
          }
        },
        {
          path: '/t/scan_unsubmit_exercise',   //随堂评测--查看未提交学生
          name: 'scan_unsubmit_exercise',
          component: resolve => require(['../components/pages/t/scan_unsubmit_exercise.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/exerciseInRoom'
          }
        },
        {
          path: '/t/firstExamples',   //首页--课堂例题--进入页面
          name: 'firstExamples',
          component: resolve => require(['../components/pages/t/firstExamples.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/index'
          }
        },
        {
          path: '/t/knows_statistics',   //教学诊断--知识点统计
          name: 'knows_statistics',
          component: resolve => require(['../components/pages/t/knows_statistics.vue'], resolve),
          meta: {
            subname: 'teaching',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/studentTotal',   //教学诊断--班级学生统计
          name: 'studentTotal',
          component: resolve => require(['../components/pages/t/studentTotal.vue'], resolve),
          meta: {
            subname: 'teaching',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/process',   //教学过程数据
          name: 'process',
          component: resolve => require(['../components/pages/t/process.vue'], resolve),
          meta: {
            subname: 'teaching',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/processNext',   //教学过程数据->下一步
          name: 'processNext',
          component: resolve => require(['../components/pages/t/processNext.vue'], resolve),
          meta: {
            activeName: '/t/process',
            subname: 'teaching',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/processNextList',   //教学过程数据->下一步->下一步
          name: 'processNextList',
          component: resolve => require(['../components/pages/t/processNextList.vue'], resolve),
          meta: {
            activeName: '/t/process',
            subname: 'teaching',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/studentTotal_class_stu_list',   //教学诊断--班级学生统计
          name: 'studentTotal_class_stu_list',
          component: resolve => require(['../components/pages/t/studentTotal_class_stu_list.vue'], resolve),
          meta: {
            subname: 'teaching',
            activeName: '/t/studentTotal',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/studentTotal_stu_test_sort',   //教学诊断--班级学生统计
          name: 'studentTotal_stu_test_sort',
          component: resolve => require(['../components/pages/t/studentTotal_stu_test_sort.vue'], resolve),
          meta: {
            subname: 'teaching',
            activeName: '/t/studentTotal',
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/firstexerciseInRoom',   //随堂练习首页（新建）
          name: 'firstexerciseInRoom',
          component: resolve => require(['../components/pages/t/firstexerciseInRoom.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/index'
          }
        },
        {
          path: '/t/exerciseListDesc',   //试题列表--查看--详情
          name: 'exerciseListDesc',
          component: resolve => require(['../components/pages/t/exerciseListDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/echart_exerciseListDesc',   //试题列表--查看--详情（统计）
          name: 'echart_exerciseListDesc',
          component: resolve => require(['../components/pages/t/echart_exerciseListDesc.vue'], resolve),
          meta: {
            // subname: 'exam',
            requireAuth: 'tuser',
            activeName: '/t/exam_underline_list',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/echart_student',   //试题列表--查看--详情--某一个人的统计图（统计）
          name: 'echart_student',
          component: resolve => require(['../components/pages/t/echart_student.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/echart_exam_ques_check_online',   //试题列表--查看--ab卷
          name: 'echart_exam_ques_check_online',
          component: resolve => require(['../components/pages/t/echart_exam_ques_check_online.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
          }
        },
        {
          path: '/t/paper_test',   //试卷统计（新）
          name: 'paper_test',
          component: resolve => require(['../components/pages/t/paper_test.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName:'/t/exam_online_list',
            subname:'exam'
          }
        },
        {
          path: '/t/echartTotal',   //试题列表--查看--统计
          name: 'echartTotal',
          component: resolve => require(['../components/pages/t/echartTotal.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/echart_knowList',   //试题列表--查看--统计——知识点详情列表
          name: 'echart_knowList',
          component: resolve => require(['../components/pages/t/echart_knowList.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },

        {
          path: '/t/homework_list',   //课后作业列表
          name: 'homework_list',
          component: resolve => require(['../components/pages/t/homework_list.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false,
          }
        },
        {
          path: '/t/homework_ques_check',   //课后作业查看试卷详情
          name: 'homework_ques_check',
          component: resolve => require(['../components/pages/t/homework_ques_check.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/homework_list'
          }
        },

        {
          path: '/t/home_controlDesc',   //课后作业监控
          name: 'home_controlDesc',
          component: resolve => require(['../components/pages/t/home_controlDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/homework_list'
          }
        },
        {
          path: '/t/scan_unsubmit_homework',   //查看课后作业未提交人员
          name: 'scan_unsubmit_homework',
          component: resolve => require(['../components/pages/t/scan_unsubmit_homework.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/homework_list'
          }
        },
        {
          path: '/t/scan_askQuestion',   //查看答题情况--学生列表
          name: 'scan_askQuestion',
          component: resolve => require(['../components/pages/t/scan_askQuestion.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/homework_list',
            parentName: '',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/scan_askQuestion_online',   //查看答题情况（线下）
          name: 'scan_askQuestion_online',
          component: resolve => require(['../components/pages/t/scan_askQuestion_online.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/exam_underline_list',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/echart_stu_answerDesc',   //查看答题情况
          name: 'echart_stu_answerDesc',
          component: resolve => require(['../components/pages/t/echart_stu_answerDesc.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/homework_list',
            isBack: false
          }
        },


        {
          path: '/t/exam_underline_list',   //线下考试列表
          name: 'exam_underline_list',
          component: resolve => require(['../components/pages/t/exam_underline_list.vue'], resolve),
          meta: {
            subname: 'exam',
            activeName: '/t/exam_underline_list',
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/exam_underlist_class_list',   //线下考试列表--班级列表
          name: 'exam_underlist_class_list',
          component: resolve => require(['../components/pages/t/exam_underlist_class_list.vue'], resolve),
          meta: {
            subname: 'exam',
            activeName: '/t/exam_underline_list',
            requireAuth: 'tuser',
            // keepAlive: true,
            // isBack: false
          }
        },
        {
          path: '/t/judge_class_list',   //判卷班级列表
          name: 'judge_class_list',
          component: resolve => require(['../components/pages/t/judge_class_list.vue'], resolve),
          meta: {
            subname: 'exam',
            activeName: '/t/exam_underline_list',
            requireAuth: 'tuser',
          }
        },
        {
          path: '/t/judge_paper',   //判卷学生列表
          name: 'judge_paper',
          component: resolve => require(['../components/pages/t/judge_paper.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/judge_paper_ques',   //判卷按题目判卷
          name: 'judge_paper_ques',
          component: resolve => require(['../components/pages/t/judge_paper_ques.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/exam_underline_judge_paper',   //线下考试-班级列表-学生列表判卷学生列表
          name: 'exam_underline_judge_paper',
          component: resolve => require(['../components/pages/t/exam_underline_judge_paper.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'exam',
            activeName: '/t/exam_underline_list',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/judge_sub_paper',   //判卷主观题列表
          name: 'judge_sub_paper',
          component: resolve => require(['../components/pages/t/judge_sub_paper.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'exam',
            activeName: '/t/exam_online_list',
          }
        },
        {
          path: '/t/judge_sub_paper_ques',   //判卷主观题列表按题目判卷
          name: 'judge_subjudge_sub_paper_ques_paper',
          component: resolve => require(['../components/pages/t/judge_sub_paper_ques.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'exam',
            activeName: '/t/exam_online_list',
          }
        },
        {
          path: '/t/enter_grade',   //线下考试录入成绩
          name: 'enter_grade',
          component: resolve => require(['../components/pages/t/enter_grade.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'exam',
            activeName: '/t/exam_underline_list'
          }
        },
        {
          path: '/t/exam_template_list',   //快速评测
          name: 'exam_template_list',
          component: resolve => require(['../components/pages/t/exam_template_list.vue'], resolve),
          meta: {
            requireAuth: 'tuser'
          }
        },
        {
          path: '/t/set_examPaper_template',   //快速评测
          name: 'set_examPaper_template',
          component: resolve => require(['../components/pages/t/set_examPaper_template.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            activeName: '/t/exam_template_list',
            keepAlive: true,
            isBack: false
          }
        },

        {
          path: '/t/answerQuestion', //互问互答
          name: 'answerQuestion',
          component: resolve => require(['../components/pages/t/answerQuestion.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
            subname: 'teaStd',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/answerQuestion2', //互问互答
          name: 'answerQuestion2',
          component: resolve => require(['../components/pages/t/answerQuestion2.vue'], resolve),
          meta: {
            subname: 'teaStd',
            requireAuth: 'tuser',
            activeName: '/t/answerQuestion',
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/t/answerQuestion3', //回复详情
          name: 'answerQuestion3',
          component: resolve => require(['../components/pages/t/answerQuestion3.vue'], resolve),
          meta: {
            subname: 'teaStd',
            requireAuth: 'tuser',
            activeName: '/t/answerQuestion'
          }
        },
        {
          path: '/t/teachResources', //教学资源
          name: 'teachResources',
          component: resolve => require(['../components/pages/t/teachResources.vue'], resolve),
          meta: {
            requireAuth: 'tuser',
          }
        },
        {
          path: '/t/sourcesFile', //资源管理
          name: 'sourcesFile',
          component: resolve => require(['../components/pages/t/sourcesFile.vue'], resolve),
          meta: {

          }
        }


      ]
    },


  ]
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let allowBack = 1    //    给个默认值true
  if (to.meta.allowBack !== undefined && to.query.type == 'exam') {
    allowBack = to.meta.allowBack
  }
  if (allowBack == 0) {
    history.pushState(null, null, location.href)
  }
  sessionStorage.setItem('allowBack', allowBack);
  if (to.meta.requireAuth == 'auser') {
    if (window.sessionStorage.getItem('auser')) {
      next();
    } else {
      next({
        path: '/a/login',
        query: {redirect: to.fullPath}
      })
    }
  } else if (to.meta.requireAuth == 'tuser') {
    if (window.sessionStorage.getItem('tuser')) {
      next();
    } else {
      next({
        path: '/t/login',
        query: {redirect: to.fullPath}
      })
    }
  } else if (to.meta.requireAuth == 'suser') {
    if (window.sessionStorage.getItem('suser')) {
      next();
    } else {
      next({
        path: '/s/login',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next();
  }
});

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.errcode == 9000) {
      if (router.currentRoute.fullPath.indexOf('/a/') >= 0) {
        Vue.prototype.$Modal.warning({
          title: '系统提示',
          content: '请重新登录',
          onOk: () => {
            window.sessionStorage.removeItem('auser');
            router.replace({
              path: '/a/login',
              query: {redirect: router.currentRoute.fullPath}
            });
          }
        });
      } else if (router.currentRoute.fullPath.indexOf('/t/') >= 0) {
        Vue.prototype.$Modal.warning({
          title: '系统提示',
          content: '请重新登录',
          onOk: () => {
            window.sessionStorage.removeItem('tuser');
            router.replace({
              path: '/t/login',
              query: {redirect: router.currentRoute.fullPath}
            });
          }
        });
      } else if (router.currentRoute.fullPath.indexOf('/s/') >= 0) {
        Vue.prototype.$Modal.warning({
          title: '系统提示',
          content: '请重新登录',
          onOk: () => {
            window.sessionStorage.removeItem('suser');
            router.replace({
              path: '/s/login',
              query: {redirect: router.currentRoute.fullPath}
            });
          }
        });
      }
      return;
    }
    return response;
  },
  error => {
    if (error.response) {
      console.log('errorerror=====', error.response);
    }
  });


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js